import { useEffect, useContext } from 'react';
import { AppContext } from '../../context/App-context';
import { QuestionsContext } from '../../context/Questions';
import { IDataTable } from '../../interfaces/items';
import HttpAxios from '../../hooks/http';
import { EErrorMsg } from '../../statics/controls';
import dayjs from 'dayjs';
import { IParameters } from '../../interfaces/items';
import enviroment from '../../../enviroments/enviroment';
import IconExcel from '../../../images/excel.svg';
import IconDownload from '../../../images/download.svg';
import IconAttachWhite from '../../../images/attach-white.svg';
import './table.scss';

export interface ITable {
    data: IDataTable[];
    header: string[];
    total: number;
    parameters: IParameters;
}

const Table = ({ data, parameters, header, total }: ITable) => {
    const { changeIsLoading, changeSnackBar } = useContext(AppContext);
    const { changeShowModalUser, changeUserId } = useContext(QuestionsContext);

    const handleExport = () => {
        changeIsLoading(true);

        HttpAxios.post('/forms/export', parameters)
            .then((res: any) => {
                const { err, download_url } = res?.data || {};
                changeIsLoading(false);

                if (err) {
                    changeSnackBar(EErrorMsg.generic);
                } else {
                    handleDownload(download_url);
                }
            })
            .catch(() => {
                changeIsLoading(false);
                changeSnackBar(EErrorMsg.generic);
            });
    };

    const handleDownload = (urlFile: string = '') => {
        const link = document.createElement('a');
        link.href = urlFile;
        link.setAttribute(
            'download',
            `${urlFile.split('/')[urlFile.split('/').length - 1]}`
        );
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
            link?.parentNode?.removeChild(link);
        }, 100);
    };

    const formatDate = (date: string | null = '') => {
        return date ? dayjs(date).format(enviroment.search.formatDate) : '';
    };

    const formatField = (str: string | null = '') => {
        return !!str?.trim() ? str?.trim() : '-';
    };

    const formatFieldNum = (num: number | null = 0) => {
        return (!!num ? num : 0) + '%';
    };

    const donwloadAttach = (url: string | null) => {
        if (url) {
            const urlFile = url;
            const link = document.createElement('a');
            link.href = urlFile;
            link.target = '_blank';
            link.setAttribute(
                'download',
                `${url.split('/')[url.split('/').length - 1]}`
            );
            document.body.appendChild(link);
            link.click();
            link?.parentNode?.removeChild(link);
        } else {
            changeSnackBar(EErrorMsg.generic);
        }
    };

    const getUser = (idUser: number) => {
        changeUserId(idUser);
        changeShowModalUser(true);
    };

    useEffect(() => {}, [data]);

    return (
        <div className="TableContent">
            <div className="TableActions">
                <div className="TableTotal">
                    {total > 0 && 'Total de registros: ' + total}
                </div>
                <div className="separate"></div>
                {total > 0 && (
                    <button
                        className="button buttonExcel"
                        type="button"
                        onClick={handleExport}
                    >
                        <img
                            src={IconExcel}
                            alt="Search"
                            className="buttonIconLeft"
                        />
                        Exportar
                    </button>
                )}
            </div>
            <div className="Table">
                <table>
                    <thead>
                        <tr>
                            {header.map((item, ind) => (
                                <th key={'head' + ind}>{item}</th>
                            ))}
                            <th>
                                <img src={IconAttachWhite} alt="Adjuntos" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, ind) => (
                            <tr key={'body' + ind}>
                                <td
                                    className="TdClick"
                                    onClick={() => getUser(item.idusuario)}
                                >
                                    {formatField(
                                        formatDate(item.fecharegistro)
                                    )}
                                </td>
                                <td
                                    className="TdClick"
                                    onClick={() => getUser(item.idusuario)}
                                >
                                    {formatField(item.razonsocial)}
                                </td>
                                <td
                                    className="TdClick"
                                    onClick={() => getUser(item.idusuario)}
                                >
                                    {formatField(item.ruc)}
                                </td>
                                <td
                                    className={
                                        (Boolean(item.postulacionenviada)
                                            ? 'StateSent'
                                            : 'StatePending') +
                                        ' ' +
                                        'TdClick'
                                    }
                                    onClick={() => getUser(item.idusuario)}
                                >
                                    {Boolean(item.postulacionenviada)
                                        ? 'Enviado'
                                        : 'Pendiente'}
                                </td>
                                <td
                                    className="TdClick TdClickCenter"
                                    onClick={() => getUser(item.idusuario)}
                                >
                                    {formatFieldNum(item.avancepostulacion)}
                                </td>
                                <td
                                    className="TdClick"
                                    onClick={() => getUser(item.idusuario)}
                                >
                                    {formatField(item.nombre)}
                                </td>
                                <td
                                    className="TdClick"
                                    onClick={() => getUser(item.idusuario)}
                                >
                                    {formatField(item.apellido)}
                                </td>
                                <td
                                    className="TdClick"
                                    onClick={() => getUser(item.idusuario)}
                                >
                                    {formatField(item.cargo)}
                                </td>
                                <td
                                    className="TdClick"
                                    onClick={() => getUser(item.idusuario)}
                                >
                                    {formatField(item.email)}
                                </td>
                                <td
                                    className="TdClick"
                                    onClick={() => getUser(item.idusuario)}
                                >
                                    {formatField(item.telefono)}
                                </td>
                                <td>
                                    {item.urldeclaracionjurada && (
                                        <img
                                            className="TableIconDocument"
                                            src={IconDownload}
                                            title="Documento"
                                            alt="Documento"
                                            onClick={() =>
                                                donwloadAttach(
                                                    item.urldeclaracionjurada
                                                )
                                            }
                                        />
                                    )}
                                    {item.urlvideo && (
                                        <img
                                            className="TableIconVideo"
                                            src={IconDownload}
                                            title="Video"
                                            alt="Video"
                                            onClick={() =>
                                                donwloadAttach(item.urlvideo)
                                            }
                                        />
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Table;
